/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import './ChatComponent.css';
import CSS from 'csstype';
import { relative } from 'path';
const RouteComponentProps = require('react-router-dom').RouteComponentProps;
const withRouter = require('react-router-dom').withRouter;

function ImgDialog( match : typeof RouteComponentProps) : JSX.Element{
    const search = match.location.search;
    const params = new URLSearchParams(search);

    const url = params.get('url')?.valueOf();

    function closeWindow() {
        window.open('', '_self', '');
        window.close();
    }

    const imageStyle: CSS.Properties = {
        width: '100%',
        height: '100%'
    }

    return(
        <>
            <img style={imageStyle} src={url} onClick={closeWindow} />
        </>
    );
}

export default withRouter(ImgDialog);